<template>
  <layout>
    <div class="section">
      <div class="content">
        <div class="nav-warrp">
          <div class="nav-item" @click="evt_select(0)">
            <img src="../../assets/image/domain-icon1.png" alt="" srcset="" />
            <div class="info">
              <div class="f-text">域名注册</div>
              <div class="d-text">首年注册</div>
            </div>
          </div>
          <div class="nav-item" @click="evt_select(1)">
            <img src="../../assets/image/domain-icon2.png" alt="" srcset="" />
            <div class="info">
              <div class="f-text">续费价格</div>
              <div class="d-text">单年续费价格</div>
            </div>
          </div>
          <div class="nav-item" @click="evt_select(2)">
            <img src="../../assets/image/domain-icon3.png" alt="" srcset="" />
            <div class="info">
              <div class="f-text">转入价格</div>
              <div class="d-text">含一年续费价格</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 53px">
          <Table
            class="custom-table"
            stripe
            border
            :columns="columns"
            :data="list"
          >
          </Table>
        </div>
      </div>
    </div>
  </layout>
</template>
<script>
import layout from "./components/layout.vue";
import { getPriceList } from "api/domain.js";
export default {
  name: "price",
  components: {
    layout,
  },
  data() {
    return {
      columns: [
        {
          width: 600,
          title: "域名后缀",
          key: "name",
          align: "center",
          render: (h, { row }) => {
            return h(
              "div",
              {
                style: {
                  paddingLeft: "40px",
                  textAlign: "left",
                  display: "flex",
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      marginRight: "40px",
                      textDecoration: "underline",
                      flex: "0 0 100px",
                    },
                  },
                  row.domainSufName
                ),
                h(
                  "span",
                  {
                    style: {
                      flex: "1",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 1,
                      "-webkit-box-orient": "vertical",
                    },
                  },
                  row.desc
                ),
              ]
            );
          },
        },
        {
          key: "levelName0",
          align: "center",
          renderHeader: (h) => {
            return h("span", "普通会员");
          },
          render: (h, { row }) => {
            if (
              row.sufPriceList != null &&
              row.sufPriceList[0].activityPrice === row.sufPriceList[0].price
            ) {
              return h("span", `${row.sufPriceList[0].activityPrice +'/年' || "-"}`);
            } else if (
              row.sufPriceList != null &&
              row.sufPriceList[0].activityPrice == null
            ) {
              return h("span", `${row.sufPriceList[0].price}`+'/年');
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.sufPriceList != null ? row.sufPriceList[0].price+'/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.sufPriceList != null
                  ? row.sufPriceList[0].activityPrice +'/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName1",
          align: "center",
          renderHeader: (h) => {
            return h("span", "金牌会员");
          },
          render: (h, { row }) => {
            if (
              row.sufPriceList != null &&
              row.sufPriceList[1].activityPrice === row.sufPriceList[1].price
            ) {
              return h("span", `${row.sufPriceList[1].activityPrice+'/年' || "-"}`);
            } else if (
              row.sufPriceList != null &&
              row.sufPriceList[1].activityPrice == null
            ) {
              return h("span", `${row.sufPriceList[1].price+'/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.sufPriceList != null ? row.sufPriceList[1].price+'/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.sufPriceList != null
                  ? row.sufPriceList[1].activityPrice+'/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName2",
          align: "center",
          renderHeader: (h) => {
            return h("span", "钻石会员");
          },
          render: (h, { row }) => {
            if (
              row.sufPriceList != null &&
              row.sufPriceList[2].activityPrice === row.sufPriceList[2].price
            ) {
              return h("span", `${row.sufPriceList[2].activityPrice+'/年' || "-"}`);
            } else if (
              row.sufPriceList != null &&
              row.sufPriceList[2].activityPrice == null
            ) {
              return h("span", `${row.sufPriceList[2].price+'/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.sufPriceList != null ? row.sufPriceList[2].price+'/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.sufPriceList != null
                  ? row.sufPriceList[2].activityPrice+ '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName3",
          align: "center",
          renderHeader: (h) => {
            return h("span", "皇冠会员");
          },
          render: (h, { row }) => {
            if (
              row.sufPriceList != null &&
              row.sufPriceList[3].activityPrice === row.sufPriceList[3].price
            ) {
              return h("span", `${row.sufPriceList[3].activityPrice+'/年' || "-"}`);
            } else if (
              row.sufPriceList != null &&
              row.sufPriceList[3].activityPrice == null
            ) {
              return h("span", `${row.sufPriceList[3].price+'/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.sufPriceList != null ? row.sufPriceList[3].price+'/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.sufPriceList != null
                  ? row.sufPriceList[3].activityPrice+'/年' || ""
                  : ""
              ),
            ]);
          },
        },
      ],
      list: [],
      type: 0,
    };
  },
  created() {
    this.req_getPriceList();
  },
  methods: {
    req_getPriceList() {
      getPriceList(this.type).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.list = data;
        }
      });
    },
    evt_select(type) {
      this.type = type;
      this.req_getPriceList();
    },
  },
};
</script>
<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 210px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .nav-warrp {
      display: flex;
      .nav-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 120px;
        cursor: pointer;
        .info {
          margin-left: 30px;
          .f-text {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
          }
          .d-text {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
          }
        }
        &:first-child {
          background: url("../../assets/image/domain-item-bg.png") no-repeat;
          background-size: contain;
        }
        &:nth-child(2) {
          background: url("../../assets/image/domain-item2-bg.png") no-repeat;
          background-size: contain;
        }
        &:nth-child(3) {
          background: url("../../assets/image/domain-item3-bg.png") no-repeat;
          background-size: contain;
        }
      }
    }
  }
}
</style>
